export const companySearch = {
  'companySearch.title': 'Informations Entreprise',
  'companySearch.searchPlaceholder': 'Recherche par nom d\'entreprise, SIREN, ou adresse...',
  'companySearch.searchButton': 'Rechercher',
  'companySearch.useManualEntry': 'Saisie Manuelle',
  'companySearch.useCompanySearch': 'Utiliser la Recherche',
  'companySearch.searchLabel': 'Rechercher des Entreprises Françaises',
  'companySearch.updateLabel': 'Mettre à Jour les Informations d\'Entreprise',
  'companySearch.updatePlaceholder': 'Rechercher pour mettre à jour les informations...',
  'companySearch.noResults': 'Aucune entreprise trouvée pour',
  'companySearch.noResultsHint': 'Essayez de rechercher avec un nom d\'entreprise différent ou un numéro SIREN',
  'companySearch.selected': 'Entreprise Sélectionnée',
  'companySearch.selectedDesc': '{{name}} sélectionnée (SIREN: {{siren}})',
  'companySearch.searchError': 'Erreur de Recherche',
  'companySearch.searchErrorDesc': 'Échec de la recherche d\'entreprises. Veuillez réessayer.',
  'companySearch.searchFailed': 'Recherche Échouée',
  'companySearch.searchFailedDesc': 'Impossible de rechercher des entreprises pour le moment.',
  'companySearch.rateLimited': 'Limite de débit dépassée. Veuillez réessayer dans quelques secondes.',
  'companySearch.employees.NN': 'Non spécifié',
  'companySearch.employees.00': 'Aucun employé',
  'companySearch.employees.01': '1-2 employés',
  'companySearch.employees.02': '3-5 employés',
  'companySearch.employees.03': '6-9 employés',
  'companySearch.employees.11': '10-19 employés',
  'companySearch.employees.12': '20-49 employés',
  'companySearch.employees.21': '50-99 employés',
  'companySearch.employees.22': '100-199 employés',
  'companySearch.employees.31': '200-249 employés',
  'companySearch.employees.32': '250-499 employés',
  'companySearch.employees.41': '500-999 employés',
  'companySearch.employees.42': '1000-1999 employés',
  'companySearch.employees.51': '2000-4999 employés',
  'companySearch.employees.52': '5000-9999 employés',
  'companySearch.employees.53': '10000+ employés'
} as const;